export enum Provider {
  AW       = 'AW',
  BING     = 'BING',
  FACEBOOK = 'FACEBOOK',
}
